export function renderUser(user) {
    const { email, firstName, lastName } = user;
    if (firstName && lastName) {
        return `${firstName} ${lastName}`;
    }
    return email;
}
